/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';

export const FileComp = (props) => {
  const { formFields } = props;
  return (
    <>
      <h5>Required Documents</h5>
      <Form style={{ marginBottom: '5rem' }}>
        {formFields?.map((_field) => {
          return (
            <Form.Group className="mb-3">
              <Form.Label>{_field?.compProps?.label}</Form.Label>
              <Form.Control type="file" multiple />
            </Form.Group>
          );
        })}
      </Form>
    </>
  );
};
